module.exports = __webpack_public_path__ + "img/CVillagers64_ua.53ecb1a9.webp";